import {StackPlayerClassifier as BaseStackPlayerClassifier} from 'services/stack-player-classifier';
import KeyPlayerStackMarker from './key-player-stack-marker';
import Const from 'constants';
import {getUnique} from 'helpers/array-helper';

class StackPlayerClassifier extends BaseStackPlayerClassifier {
    constructor(params) {
        super();
        const {stacking, simplexLineup, players} = params;

        this._players = players;
        this._stacking = stacking;
        this._simplexLineup = simplexLineup;

        const {primaryStackGroups, secondaryStackGroups} = this._getNonIntersectedGroupsOfStackedPlayers();

        
        this._primaryStackGroups = this._orderPrimaryStackGroups(primaryStackGroups);
        this._secondaryStackGroups = secondaryStackGroups;
    }

    _orderPrimaryStackGroups(primaryStackGroups) {
        const primaryStackQBGroups = [];
        const primaryStackNonQBGroups = [];
        primaryStackGroups.forEach((group) => {
            for (let playerId of group) {
                const player = this._players.getPlayer(playerId);

                if (player && player.positionName === 'QB') {
                    primaryStackQBGroups.push(group);
                    return;
                }
            }

            primaryStackNonQBGroups.push(group);
        });

        return [...primaryStackQBGroups, ...primaryStackNonQBGroups];
    }

    _getNonIntersectedGroupsOfStackedPlayers() {
        const stackItemIds = this._getStackItemIds();
        const {primaryStackGroups, secondaryStackGroups} = this._getGroupsOfStackedPlayers(stackItemIds);

        return {
            primaryStackGroups: this._makeGroupsUnique(primaryStackGroups),
            secondaryStackGroups: this._makeGroupsUnique(secondaryStackGroups),
        };
    }

    _makeGroupsUnique(groups) {
        const uniqueGroups = [];
        groups.forEach((group) => {
            if (isEmpty(uniqueGroups)) {
                uniqueGroups.push(group);
                return;
            }
            for (let key in uniqueGroups) {
                if (arrayDuplicates(group, uniqueGroups[key]).length) {
                    uniqueGroups[key] = getUnique([...uniqueGroups[key], ...group]);
                    return;
                }
            }
            uniqueGroups.push(group);
        });

        return uniqueGroups;
    }

    _getStackItemIds() {
        const simplexUnitIds = this._simplexLineup.getRaw(Const.LP_KEY_UNIT_PREFIX);

        return KeyPlayerStackMarker.pickMarkedBySuffix(simplexUnitIds);
    }

    _getGroupsOfStackedPlayers(stackItemIds) {
        const lineupUnitIds = this._simplexLineup.getDistilled(Const.LP_UNIT_PREFIX);
        const primaryStackGroups = [];
        const secondaryStackGroups = [];
        stackItemIds.map((itemId) => {
            if (!this._stacking.hasOwnProperty(itemId)) {
                return;
            }

            const {keys, players, isPrimaryStack} = this._stacking[itemId];
            const [keyPlayerId] = keys;

            const stackedPlayers = [keyPlayerId];

            players
            .filter((playerId) => inArray(String(playerId), lineupUnitIds))
            .forEach((playerId) => stackedPlayers.push(playerId));

            isPrimaryStack ? primaryStackGroups.push(stackedPlayers) : secondaryStackGroups.push(stackedPlayers);
        });

        return {primaryStackGroups, secondaryStackGroups};
    }

    isPlayerFromPrimaryStack(player) {
        return inArray(player.getId(), this._primaryStackGroups[0] || []);
    }

    isPlayerFromSecondaryStack(player) {
        for (let key in this._secondaryStackGroups) {
            if (inArray(player.getId(), this._secondaryStackGroups[key])) {
                return true;
            }
        }

        return false;
    }

    isPlayerFromThirdStack(player) {
        return inArray(player.getId(), this._primaryStackGroups[1] || []);
    }

    isPlayerFromFourthStack(player) {
        return inArray(player.getId(), this._primaryStackGroups[2] || []);
    }

    isPlayerFromFifthStack(player) {
        return inArray(player.getId(), this._primaryStackGroups[3] || []);
    }
}

export {StackPlayerClassifier};
